(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const choices = form.querySelector('[data-giggle-dish-choices]');
  if (!choices) return;
  const variant = form.querySelector('[name="id"]');
  const needsChoices = variant && variant.value === '57281867088212';
  choices.setCustomValidity('');
  if (needsChoices && !choices.value.trim()) {
    event.preventDefault();
    event.stopImmediatePropagation();
    choices.setCustomValidity('Please enter your four chosen designs.');
    choices.reportValidity();
    choices.focus();
  }
}, true);
document.addEventListener('input', function(event) {
  if (event.target.matches('[data-giggle-dish-choices]')) event.target.setCustomValidity('');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giggle-product-details"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('giggle-product-tabs')) customElements.define('giggle-product-tabs',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const tabs=[...this.querySelectorAll('[role=tab]')];
const select=tab=>tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;this.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active;});
tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let next=index;if(e.key==='ArrowRight')next=(index+1)%tabs.length;else if(e.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();select(tabs[next]);tabs[next].focus();});});
}});
  } catch(e) { console.error(e); }
})();

})();
